import {
  ButtonGroup,
  SkeletonText,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { flexRender } from "@tanstack/react-table";
import iconArrowLeftRight from "assets/icons/icon-arrow-left-right.svg";
import ButtonRemoveResource from "components/ButtonRemoveResource";
import ButtonEdit from "components/ui/ButtonEdit";
import EmptyList from "components/ui/EmptyList";
import Pagination from "components/ui/Pagination";
import { useDynamicTableContext } from "contexts/DynamicTableContext";

export default function ThemesList() {
  const {
    table,
    queryResult: { data = [], isLoading },
  } = useDynamicTableContext();

  const hasData = data.length > 0;
  const hasResult = table.getRowCount() > 0;

  return (
    <SkeletonText isLoaded={!isLoading}>
      {hasResult && (
        <>
          <Table mt="25px">
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Idioma</Th>
                <Th>Status</Th>
                <Th w="120px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {table.getRowModel().rows.map((row) => (
                <Tr key={`user-${row.id}`}>
                  {row.getVisibleCells().map((cell) => (
                    <Td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Td>
                  ))}
                  <Td textAlign="right">
                    <ButtonGroup>
                      <ButtonGroup>
                        <ButtonEdit to={`/temas/${row.original.id}`} />
                      </ButtonGroup>
                      <ButtonRemoveResource
                        id={row.original.id}
                        pathName="content-parameters"
                        queryKey={["contentParameters", { type: "THEME" }]}
                      />
                    </ButtonGroup>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Pagination table={table} />
        </>
      )}
      {(!hasData || !hasResult) && (
        <EmptyList
          icon={iconArrowLeftRight}
          title={
            !hasData
              ? "Você ainda não possui nenhum tema cadastrado"
              : "Nenhum resultado encontrado"
          }
          description={hasData ? "" : "Use o botão acima para cadastrar"}
          isTable
        />
      )}
    </SkeletonText>
  );
}
